import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setPermissionGeolocation, setPosition } from '../store/actions';

export const useGeolocation = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    let watchId;

    const startWatchingPosition = () => {
      if (!navigator.geolocation) {
        return 'Geolocation not supported';
      }

      // start watching position
      watchId = navigator.geolocation.watchPosition(
        pos => {
          const { latitude, longitude } = pos.coords;

          dispatch(setPosition({ latitude, longitude }));
          dispatch(setPermissionGeolocation('granted'));
        },
        err => {
          dispatch(setPosition(null));
          dispatch(setPermissionGeolocation('denied'));
          return err.message;
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        }
      );
    };

    startWatchingPosition();

    return () => {
      if (watchId !== undefined) {
        navigator.geolocation.clearWatch(watchId);
      }
    };
  }, [dispatch]);
};
